import { createHistory, useBasename, useQueries } from 'history';
import config from './config';

// eslint-disable-next-line import/prefer-default-export
export const history = useQueries(useBasename(createHistory))({
  basename: config.pathPrefix,
});



// WEBPACK FOOTER //
// ./src/history.js